<script lang="jsx">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Icon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'

  import initStyle from './style'

  initStyle()

  // eslint-disable-next-line max-len
  const checkedPath = ['M9.225 1.671a.469.469 0 00-.662.035L3.31 7.539 1.444 5.467a.469.469 0 00-.697.627l2.209 2.453a.469.469 0 00.48.136.467.467 0 00.233-.141l5.59-6.209a.469.469 0 00-.034-.662z']
  const minusPath = ['M9.5 4.5h-9a.5.5 0 000 1h9a.5.5 0 000-1z']

  export default {
    name: 'StatelessBeerCheckbox',
    components: {
      Icon,
      NewBsBox,
    },
    props: {
      /**
       * @type {true|false}
       * @see style
       */
      indeterminate: {
        type: [Boolean],
        default: false,
      },
      /**
       * 是否初始选中
       * @type {true|false}
       */
      checked: {
        type: [Boolean],
        default: false,
      },
      /**
       * 在 modelValue 是 array 的时候判断是否选中的逻辑
       */
      isInclude: {
        type: Function,
        required: false,
      },
      /**
       * 在 modelValue 是 array 的时候判断是否选中的的逻辑，作为 isInlude 的补充
       */
      filterFn: {
        type: Function,
        required: false,
      },
      /**
       * v-model 的值
       */
      modelValue: {
        type: Boolean,
        default: undefined,
      },
      /**
       * 选项的值
       */
      value: {
        type: [String, Number, Boolean],
        default: false,
      },
      /**
       * 框框的标签
       */
      label: String,
      /**
       * 选项是否可选
       * @type {true|false}
       * @see style
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       *  wrapper bs to override default
       */
      bs: {
        type: Object,
        default: () => ({ }),
      },
      /**
       *  label bs to override default
       */
      labelBs: {
        type: Object,
        default: () => ({ }),
      },
      handleChange: {
        type: Function,
        required: true,
      },
    },
    setup(props) {
      return () => {
        const {
          bs, label, value, modelValue, indeterminate, handleChange, disabled, labelBs,
        } = props

        let currentChecked = false
        if (indeterminate) {
          currentChecked = true
        } else {
          currentChecked = !!modelValue
        }

        return (
        <NewBsBox
          as="label"
          bs={{
            'cmp.checkbox': 'wrapper',
            ...bs,
          }}
        >
          <NewBsBox
            as="input"
            bs={{
              'cmp.checkbox': 'inputNative',
            }}
            checked={currentChecked}
            disabled={disabled}
            value={value}
            type="checkbox"
            onClick={() => handleChange(!currentChecked)}
          />
          <NewBsBox bs={{ 'cmp.checkbox': 'control' }}>
            {currentChecked && (
              <Icon
                gridSize={10}
                size={10}
                color="white"
                iconPath={indeterminate ? minusPath : checkedPath} />
            )}
          </NewBsBox>
          <NewBsBox
            bs={{
              'cmp.checkbox': 'label',
              ...labelBs,
            }}
          >
            {label}
          </NewBsBox>
        </NewBsBox>
      )
      }
    },
  }
</script>
